export default "__VITE_ASSET__DUQgs_YT__"